import React, { useState, useEffect, createContext, useContext } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useNavigate, Link } from 'react-router-dom';
import {
  LayoutDashboard, Users, Building2, ShieldCheck, Activity,
  Settings, LogOut, Briefcase, TrendingUp, Wallet, Layers,
  Menu, Bell, Search, ShieldAlert, History, Lock, User,
  ChevronRight, Globe, Fingerprint,
  CalendarDays,
  UserPlus,
  Package,
  Receipt,
  Truck,
  Scale,
  MapPin,
  BookUser,
  FileText,
  CheckCircle2,
  Image,
  Calculator,
  UserCheck,
  ShoppingCart,
  BarChart3,
  Landmark,
  Calendar,
  CalendarCheck,
  CalendarCheck2,
  Database,
  Terminal,
  BookOpen,
  Trash,
  WifiOff,
  RefreshCw
} from 'lucide-react';

import axios from 'axios';
import SaaSPlatformOverview from './pages/SaaSPlatformOverview';
import CompanyManager from './pages/CompanyManager';

import Analytics from './pages/Analytics';
import CRMModule from './pages/CRMModule';
import ProjectList from './pages/ProjectList';
import ProjectGallery from './pages/ProjectGallery';
import InventoryModule from './pages/InventoryModule';

import AttendanceModule from './pages/AttendanceModule';
import BranchManagement from './pages/BranchManagement';
import VendorManagement from './pages/VendorManagement';

import VendorLedger from './pages/VendorLedger';
import ClientBilling from './pages/ClientBilling';
import TaxSettlement from './pages/TaxSettlement';

import CashFlowCalendar from './pages/CashFlowCalendar';
import Directory from './pages/Directory';
import ClientStatement from './pages/ClientStatement';
import ProjectTasks from './pages/ProjectTasks';
import PettyCash from './pages/PettyCash';
import MonthlyPL from './pages/MonthlyPL';
import PurchaseOrder from './pages/PurchaseOrder';
import QuotationBOQ from './pages/QuotationBOQ';

import ProjectAuditManager from './pages/ProjectAuditManager';
import MaterialPurchaseTracker from './pages/MaterialPurchaseTracker';

import MonthlyPayoutSummary from './pages/MonthlyPayoutSummary';
import SiteCostAnalysis from './pages/SiteCostAnalysis';
import SiteDetailedAudit from './pages/SiteDetailedAudit';
import GenerateInvoiceModal from './pages/GenerateInvoiceModal';
import ClientBilling1 from './pages/ClientBilling1';
import ChallanManagement from './pages/ChallanManagement';

import NewEmployeeManagement from './pages/NewEmployeeManagement';

import MonthlyAttendanceEditor from './pages/MonthlyAttendanceEditor';
import MonthlyAttendanceCalendar from './pages/MonthlyAttendanceCalendar';
import MonthlyAttendancePaymentTracker from './pages/MonthlyAttendancePaymentTracker';

import InteractiveAttendanceRegister from './pages/InteractiveAttendanceRegister';
import UserManagement from './pages/UserManagement';
import CashLedger from './pages/CashLedger';
import FactoryChallan from './pages/FactoryChallan';
import InvoiceManager from './pages/InvoiceManager';
import SuperAdminTenants from './pages/SuperAdminTenants';
import ActivityMonitor from './pages/ActivityMonitor';
import ServerIntelligence from './pages/ServerIntelligence';
import AdminMaterialRequests from './pages/AdminMaterialRequests';
import MaterialRequestScreen from './pages/MaterialRequestScreen';

import SiteDetailCenterWrapper from './pages/SiteDetailCenterWrapper';
import StaffWalletRegistry from './pages/StaffWalletRegistry';
import DeletionApprovalCenter from './pages/DeletionApprovalCenter';
// --- 1. AUTH CONTEXT ---
export const AuthContext = createContext(null);
//TODO: Payment to supervisor and then from Supervisor to employee/material etc
//TODO: Tap on Project to view project wise similar to app

const AuthProvider = ({ children }) => {
  // Initialize state from localStorage so refresh doesn't log you out
  const [user, setUser] = useState(() => {
    const saved = localStorage.getItem('user_session');
    return saved ? JSON.parse(saved) : null;
  });

  const login = async (loginId, password) => {
    try {
      const cleanLoginId = (loginId || '').trim();
      const cleanPassword = password || '';
      const response = await axios.post('https://backendibos.aartiassociates.com/login.php', {
        loginId: cleanLoginId,
        password: cleanPassword
      });
      console.log(response.data);
      if (response.data.status === "success") {
        const { token, user: userData } = response.data;

        localStorage.setItem('token', token);
        localStorage.setItem('user_session', JSON.stringify(userData));
        localStorage.setItem("user", JSON.stringify(response.data.user));
        setUser(userData);
        return userData;
      }
      if (response.data.status === "error") {
        alert(response.data.message);
      }
    } catch (error) {

      //console.error(error);
      return null;
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user_session');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

const Sidebar = ({ type }) => {
  const { user, logout } = useContext(AuthContext);
  const [searchQuery, setSearchQuery] = useState("");
  const userRole = user?.role; // 'Owner', 'Admin', 'Staff', 'Accountant'

  // Define the menu structure with groups
  const menuGroups = type === 'saas' ? [
    {
      group: "Platform Administration",
      items: [
        { label: 'Platform Overview', icon: <Globe size={18} />, path: '/saas/dashboard' },
        { label: 'Company Manager', icon: <Building2 size={18} />, path: '/saas/companies' },
        { label: 'System Audit Logs', icon: <Activity size={18} />, path: '/saas/logs' },
        { label: 'Tenant Control', icon: <Activity size={18} />, path: '/saas/tenants' },
        { label: 'Server Intelligence', icon: <Terminal size={18} />, path: '/saas/server-intelligence' },
        { label: 'Global Settings', icon: <Settings size={18} />, path: '/saas/settings' },

      ]
    }
  ] : [
    {
      group: "Executive Strategy",
      roles: ['Owner', 'Admin', 'owner', 'admin'],
      items: [
        { label: 'Executive View', icon: <LayoutDashboard size={18} />, path: '/dashboard' },
        { label: 'Project P&L', icon: <TrendingUp size={18} />, path: '/project-pnl' },
        { label: 'Cash Flow Cal', icon: <CalendarDays size={18} />, path: '/cashflow' },
        { label: 'Tax Settlement', icon: <Scale size={18} />, path: '/tax-settlement' },
        { label: 'User Management', icon: <Users size={18} />, path: '/usermanagement' },

        { label: 'Directory', icon: <BookOpen size={18} />, path: '/directory' },
        { label: 'Client Billing', icon: <Receipt size={18} />, path: '/clients1' },
        { label: 'Client Statement', icon: <FileText size={18} />, path: '/clientstatement' },
        { label: 'Admin Material Request', icon: <FileText size={18} />, path: '/AdminMaterialRequest' },
        { label: 'Staff Wallet Registry', icon: <Wallet size={18} />, path: '/StaffWalletRegistry' },
        { label: 'Delete Box', icon: <Trash size={18} />, path: '/DeletionApprovalCenter' },

      ]
    },
    {
      group: "Site Operations",
      roles: ['Owner', 'Admin', 'Staff', 'Accountant', 'office', 'Office', 'owner', 'admin', 'staff', 'Supervisor', 'supervisor'],
      items: [
        { label: 'Site / Projects', icon: <Briefcase size={18} />, path: '/projects' },
        { label: 'Material Request', icon: <FileText size={18} />, path: '/MaterialRequest' },
        { label: 'Site Progress', icon: <CheckCircle2 size={18} />, path: '/tasks' },
        { label: 'Inventory Master', icon: <Package size={18} />, path: '/inventory' },
        { label: 'Project Gallery', icon: <Image size={18} />, path: '/projectgallery' },
      ]
    },
    {
      group: "Workforce & Payroll",
      roles: ['Owner', 'Admin', 'Staff', 'office', 'Office', 'owner', 'admin', 'staff', 'Supervisor', 'supervisor'],
      items: [

        { label: 'Workforce Master', icon: <Users size={18} />, path: '/staff' },
        { label: 'Daily Attendance', icon: <UserCheck size={18} />, path: '/attendance' },
        { label: 'Bulk Upload', icon: <Wallet size={18} />, path: '/BulkAttendanceManagement' },
        { label: 'Monthly Calendar', icon: <Database size={18} />, path: '/MonthlyCalendar' },
        { label: 'Attendance Register', icon: <CalendarCheck size={18} />, path: '/MonthlyRegister' },
        { label: 'Tracker', icon: <CalendarCheck2 size={18} />, path: '/MonthlyAttendancePaymentTracker' },
        { label: 'Payouts', icon: <Wallet size={18} />, path: '/payouts' },
      ]
    },
    {
      group: "Finance & Accounts",
      roles: ['Owner', 'Admin', 'Accountant', 'Staff', 'office', 'Office', 'owner', 'admin', 'accountant', 'staff', 'Supervisor', 'supervisor'],
      items: [


        { label: 'Vendor Ledger', icon: <Layers size={18} />, path: '/vendor-ledger' },
        { label: 'Purchase Order', icon: <FileText size={18} />, path: '/purchaseorder' },
        { label: 'Material Procurement', icon: <ShoppingCart size={18} />, path: '/material-tracker' },
        { label: 'BOQ Builder', icon: <Calculator size={18} />, path: '/boq' },
        { label: 'Challan Hub', icon: <FileText size={18} />, path: '/challans' },
        { label: 'Factory Dispatch', icon: <FileText size={18} />, path: '/factorychallan' },
        { label: 'Petty Cash', icon: <Wallet size={18} />, path: '/petty-cash' },
        { label: 'Profit Analysis', icon: <BarChart3 size={18} />, path: '/project-profitability' },
        { label: 'Site Cost Analysis', icon: <Wallet size={18} />, path: '/site-cost-analysis' },
        { label: 'Cash Ledger', icon: <Landmark size={18} />, path: '/cashledger' },
        { label: 'Other Invoices', icon: <FileText size={18} />, path: '/invoices' },
      ]
    }
  ];

  // Filter groups and items based on role and search query
  const filteredGroups = menuGroups
    .map(group => ({
      ...group,
      items: group.items.filter(item => {
        const matchesRole = !group.roles || group.roles.some(r => r.toLowerCase() === (userRole || '').toLowerCase());
        const matchesSearch = item.label.toLowerCase().includes(searchQuery.toLowerCase());
        return matchesRole && matchesSearch;
      })
    }))
    .filter(group => group.items.length > 0);

  return (
    <div className="w-72 h-screen bg-white border-r border-slate-100 fixed left-0 top-0 flex flex-col shadow-[20px_0_40px_rgba(0,0,0,0.02)]">
      {/* Logo Section */}
      <div className="p-2 flex items-center gap-3">
        <img src="/icon.png" alt="AA" className="w-20 h-20 object-contain" />
        <span className="text-xl font-bold tracking-tight text-slate-900 italic">Aarti Associates</span>
      </div>

      {/* Modern Search Bar */}
      <div className="px-6 mb-4">
        <div className="relative group">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-indigo-600 transition-colors" size={16} />
          <input
            type="text"
            placeholder="Search module..."
            className="w-full bg-slate-50 border border-slate-100 rounded-xl py-2.5 pl-10 pr-4 text-xs font-bold outline-none focus:bg-white focus:border-indigo-200 focus:ring-4 ring-indigo-500/5 transition-all"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
      </div>

      {/* Nav Content */}
      <nav className="flex-1 px-4 space-y-6 overflow-y-auto scrollbar-hide pb-8">
        {filteredGroups.map((group, idx) => (
          <div key={idx} className="space-y-1">
            <h3 className="px-4 text-[10px] font-black text-slate-400 uppercase tracking-[0.15em] mb-2 flex items-center justify-between">
              {group.group}
            </h3>
            <div className="space-y-0.5">
              {group.items.map(item => (
                <Link
                  key={item.path}
                  to={item.path}
                  className="flex items-center gap-3 px-4 py-2.5 rounded-xl text-slate-500 hover:bg-indigo-50 hover:text-indigo-600 transition-all group font-semibold border border-transparent hover:border-indigo-100"
                >
                  <span className="group-hover:scale-110 transition-transform text-slate-400 group-hover:text-indigo-600">{item.icon}</span>
                  <span className="text-[13px]">{item.label}</span>
                </Link>
              ))}
            </div>
          </div>
        ))}
      </nav>

      {/* Footer / User Profile */}
      <div className="p-6 border-t border-slate-50 bg-slate-50/50 space-y-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 border border-white shadow-sm font-bold uppercase">{user?.name[0]}</div>
          <div className="overflow-hidden">
            <p className="text-sm font-bold text-slate-900 truncate">{user?.name}</p>
            <p className="text-[10px] font-bold text-indigo-500 uppercase tracking-widest">{userRole}</p>
          </div>
        </div>

        {/* Subscription Card */}
        {user?.role !== 'Super Admin' && (
          <div className="bg-white border border-slate-200 rounded-2xl p-4 shadow-sm">
            <div className="flex items-center gap-2 mb-1">
              <div className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse"></div>
              <span className="text-[9px] font-black text-slate-400 uppercase tracking-widest">Access Status</span>
            </div>
            <p className="text-[10px] font-bold text-slate-700 leading-tight">
              Expires: <span className="text-indigo-600">
                {user?.subscription_end ? new Date(user.subscription_end).toLocaleDateString('en-IN', {
                  day: '2-digit', month: 'short', year: 'numeric'
                }) : 'Lifetime'}
              </span>
            </p>
          </div>
        )}

        <button onClick={logout} className="w-full py-3 bg-white border border-slate-200 rounded-2xl text-rose-500 font-bold text-sm shadow-sm hover:bg-rose-50 hover:border-rose-100 transition-all flex items-center justify-center gap-2">
          <LogOut size={16} /> Sign Out
        </button>
      </div>
    </div>
  );
};
// --- 3. NETWORK STATUS HOOK & GLOBAL BANNER ---
const useNetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(() => navigator.onLine);
  const [isSlowNetwork, setIsSlowNetwork] = useState(false);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    const updateNetworkQuality = () => {
      if (connection) {
        const isSlow = connection.effectiveType === 'slow-2g' || connection.effectiveType === '2g';
        setIsSlowNetwork(isSlow);
      }
    };

    if (connection) {
      updateNetworkQuality();
      connection.addEventListener('change', updateNetworkQuality);
    }

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      if (connection) {
        connection.removeEventListener('change', updateNetworkQuality);
      }
    };
  }, []);

  return { isOnline, isSlowNetwork };
};

const GlobalNetworkBanner = () => {
  const { isOnline, isSlowNetwork } = useNetworkStatus();

  if (isOnline && !isSlowNetwork) return null;

  return (
    <div className={`mb-6 p-4 rounded-2xl border text-sm font-semibold flex items-center justify-between shadow-sm transition-all animate-pulse ${!isOnline
        ? 'bg-rose-50 border-rose-200 text-rose-700'
        : 'bg-amber-50 border-amber-200 text-amber-800'
      }`}>
      <div className="flex items-center gap-3">
        <div className={`p-2 rounded-xl ${!isOnline ? 'bg-rose-100 text-rose-600' : 'bg-amber-100 text-amber-600'}`}>
          <WifiOff size={20} />
        </div>
        <div>
          <p className="font-bold text-sm">
            {!isOnline ? 'Network Disconnected (Offline)' : 'Slow Network Connection Detected'}
          </p>
          <p className="text-xs opacity-90 font-medium">
            {!isOnline
              ? 'You are currently offline. Changes may not save until internet connectivity is restored.'
              : 'Your connection is slow (2G/Poor). API requests and page loads may take longer.'}
          </p>
        </div>
      </div>
      <div className="text-xs font-bold uppercase tracking-wider px-3 py-1.5 rounded-lg bg-white/80 border border-current opacity-90">
        {!isOnline ? 'Offline' : 'Low Speed'}
      </div>
    </div>
  );
};

// --- 4. PREMIUM LIGHT LOGIN PAGE ---
const LoginPage = () => {
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ loginId: '', password: '' });
  const { isOnline, isSlowNetwork } = useNetworkStatus();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!isOnline || isSubmitting) return;

    setIsSubmitting(true);
    try {
      const form = e.target;
      const rawLoginId = formData.loginId || form.elements['login_id_no_fill']?.value || form.loginId?.value || '';
      const rawPassword = formData.password || form.elements['password_no_fill']?.value || form.password?.value || '';

      const loggedInUser = await login(rawLoginId.trim(), rawPassword);

      if (loggedInUser) {
        const targetPath = '/dashboard';
        navigate(targetPath);
      } else {
        alert("Invalid Credentials! Please check your ID and Password.");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFF] flex items-center justify-center p-6 relative">
      {/* Decorative Blur Spheres */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-indigo-100 rounded-full blur-[100px] opacity-60"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-100 rounded-full blur-[100px] opacity-60"></div>

      <div className="w-full max-w-[460px] relative z-10">
        <div className="bg-white/80 backdrop-blur-xl border border-white rounded-[48px] p-12 shadow-[0_32px_64px_-16px_rgba(0,0,0,0.08)]">
          <div className="text-center mb-10">
            <img src="/icon.png" alt="Icon" className="w-32 h-32 object-contain mx-auto mb-6" />
            <h1 className="text-4xl font-black text-slate-900 tracking-tight italic">Aarti Associates <span className="text-indigo-600">IB OS</span></h1>
            <p className="text-slate-400 mt-2 font-medium">Enterprise Management Suite</p>
          </div>

          <form onSubmit={handleLogin} autoComplete="off" className="space-y-5">
            <div className="space-y-1.5">
              <label className="text-[11px] font-bold text-slate-400 uppercase tracking-widest ml-4">Login Identity</label>
              <div className="relative group">
                <User className="absolute left-5 top-1/2 -translate-y-1/2 text-slate-300 group-focus-within:text-indigo-500 transition-colors" size={18} />
                <input
                  type="text"
                  name="login_id_no_fill"
                  id="loginIdInput"
                  placeholder="Enter ID (e.g. saas_admin)"
                  required
                  autoComplete="off"
                  autoCorrect="off"
                  autoCapitalize="none"
                  spellCheck="false"
                  value={formData.loginId}
                  className="w-full bg-slate-50 border border-slate-100 rounded-2xl py-4 pl-14 pr-4 outline-none focus:bg-white focus:ring-4 focus:ring-indigo-50/50 focus:border-indigo-200 transition-all font-medium text-slate-700 placeholder:text-slate-300"
                  onChange={(e) => setFormData(prev => ({ ...prev, loginId: e.target.value }))}
                  onInput={(e) => setFormData(prev => ({ ...prev, loginId: e.target.value }))}
                />
              </div>
            </div>

            <div className="space-y-1.5">
              <label className="text-[11px] font-bold text-slate-400 uppercase tracking-widest ml-4">Password Access</label>
              <div className="relative group">
                <Lock className="absolute left-5 top-1/2 -translate-y-1/2 text-slate-300 group-focus-within:text-indigo-500 transition-colors" size={18} />
                <input
                  type="password"
                  name="password_no_fill"
                  id="passwordInput"
                  placeholder="••••••••"
                  required
                  autoComplete="new-password"
                  value={formData.password}
                  className="w-full bg-slate-50 border border-slate-100 rounded-2xl py-4 pl-14 pr-4 outline-none focus:bg-white focus:ring-4 focus:ring-indigo-50/50 focus:border-indigo-200 transition-all font-medium text-slate-700 placeholder:text-slate-300"
                  onChange={(e) => setFormData(prev => ({ ...prev, password: e.target.value }))}
                  onInput={(e) => setFormData(prev => ({ ...prev, password: e.target.value }))}
                />
              </div>
            </div>

            {/* Offline / Low Network Alert Banner if applicable */}
            {(!isOnline || isSlowNetwork) && (
              <div className={`p-3 rounded-xl text-xs font-semibold flex items-center gap-2 ${!isOnline ? 'bg-rose-50 text-rose-600 border border-rose-100' : 'bg-amber-50 text-amber-700 border border-amber-100'}`}>
                <WifiOff size={16} className="shrink-0" />
                <span>
                  {!isOnline
                    ? 'No internet connectivity. Login is disabled until reconnected.'
                    : 'Poor network connection detected. Login may take longer or fail.'}
                </span>
              </div>
            )}

            <button
              type="submit"
              disabled={!isOnline || isSubmitting}
              className={`w-full font-bold py-4 rounded-2xl transition-all shadow-xl flex items-center justify-center gap-2 mt-4 text-lg ${!isOnline || isSubmitting
                  ? 'bg-slate-300 text-slate-500 cursor-not-allowed shadow-none'
                  : 'bg-indigo-600 hover:bg-indigo-700 text-white shadow-indigo-200 active:scale-95'
                }`}
            >
              {isSubmitting ? (
                <>
                  <RefreshCw size={20} className="animate-spin" /> Verifying Credentials...
                </>
              ) : !isOnline ? (
                <>
                  <WifiOff size={20} /> Connection Offline
                </>
              ) : (
                <>
                  Unlock Portal <ChevronRight size={20} />
                </>
              )}
            </button>
          </form>

          <div className="mt-10 pt-8 border-t border-slate-50 text-center">
            <p className="text-xs text-slate-400 font-medium">ClientOrbit Pro © 2026. All Rights Reserved.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

// --- 5. APP ARCHITECTURE ---
const DashboardShell = ({ children, type }) => (
  <div className="flex bg-[#F8FAFF] min-h-screen">
    <Sidebar type={type} />
    <main className="flex-1 ml-72 p-10 overflow-y-auto">
      <GlobalNetworkBanner />
      {children}
    </main>
  </div>
);

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          {/* SaaS Admin Section */}
          <Route path="/saas/*" element={
            <ProtectedRoute type="saas">
              <DashboardShell type="saas">
                <Routes>
                  <Route path="dashboard" element={<SaaSPlatformOverview />} />
                  <Route path="companies" element={<CompanyManager />} />
                  <Route path="logs" element={<ActivityMonitor />} />
                  <Route path="tenants" element={<SuperAdminTenants />} />
                  <Route path="server-intelligence" element={<ServerIntelligence />} />

                </Routes>
              </DashboardShell>
            </ProtectedRoute>
          } />

          {/* Company Admin / Office Staff Section */}
          <Route path="/*" element={
            <ProtectedRoute type="company">
              <DashboardShell type="company">
                <Routes>
                  {/* --- Intelligence & Decision Making --- */}
                  <Route path="dashboard" element={<Analytics />} />
                  <Route path="project-pnl" element={<MonthlyPL />} />
                  <Route path="cashflow" element={<CashFlowCalendar />} />
                  <Route path="project-profitability" element={<ProjectAuditManager />} />


                  {/* --- Sales, CRM & Portfolio --- */}
                  <Route path="crm" element={<CRMModule />} />
                  <Route path="projects" element={<ProjectList />} />
                  <Route path="gallery" element={<ProjectGallery />} />
                  <Route path="boq" element={<QuotationBOQ />} />
                  <Route path="projectgallery" element={<ProjectGallery />} />

                  {/* --- Workforce & HR Operations --- */}
                  <Route path="staff" element={<NewEmployeeManagement />} />
                  <Route path="attendance" element={<AttendanceModule />} />
                  <Route path="payouts" element={<MonthlyPayoutSummary />} />
                  <Route path="branches" element={<BranchManagement />} />
                  <Route path="tasks" element={<ProjectTasks />} />

                  {/* --- Inventory & Procurement --- */}
                  <Route path="inventory" element={<InventoryModule />} />
                  <Route path="purchaseorder" element={<PurchaseOrder />} />
                  <Route path="material-tracker" element={<MaterialPurchaseTracker />} />

                  {/* --- Financials, Accounts & Taxation --- */}
                  <Route path="clients" element={<ClientBilling />} />
                  <Route path="clients1" element={<ClientBilling1 />} />
                  <Route path="clientstatement" element={<ClientStatement />} />
                  <Route path="vendormanagement" element={<VendorManagement />} />
                  <Route path="vendor-ledger" element={<VendorLedger />} />
                  <Route path="petty-cash" element={<PettyCash />} />
                  <Route path="tax-settlement" element={<TaxSettlement />} />
                  <Route path="directory" element={<Directory />} />
                  <Route path="site-cost-analysis" element={<SiteCostAnalysis />} />
                  <Route path="site-audit/:projectId" element={<SiteDetailedAudit />} />
                  <Route path="clientinvoicegenerate" element={<GenerateInvoiceModal />} />
                  <Route path="challans" element={<ChallanManagement />} />
                  <Route path='BulkAttendanceManagement' element={<MonthlyAttendanceEditor />} />
                  <Route path='MonthlyCalendar' element={<MonthlyAttendanceCalendar />} />
                  <Route path='MonthlyAttendancePaymentTracker' element={<MonthlyAttendancePaymentTracker />} />
                  <Route path='MonthlyRegister' element={<InteractiveAttendanceRegister />} />
                  <Route path='usermanagement' element={<UserManagement />} />
                  <Route path='cashledger' element={<CashLedger />} />
                  <Route path='factorychallan' element={<FactoryChallan />} />
                  <Route path="invoices" element={<InvoiceManager />} />
                  <Route path="site-intelligence/:projectId/:projectName" element={<SiteDetailCenterWrapper />} />
                  <Route path="AdminMaterialRequest" element={<AdminMaterialRequests />} />
                  <Route path='MaterialRequest' element={<MaterialRequestScreen />} />
                  <Route path='StaffWalletRegistry' element={<StaffWalletRegistry />} />
                  <Route path='DeletionApprovalCenter' element={<DeletionApprovalCenter />} />


                  {/* --- System Fallback --- */}
                  <Route path="*" element={<Navigate to="/dashboard" />} />
                </Routes>
              </DashboardShell>
            </ProtectedRoute>
          } />

          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

// Helpers
const ProtectedRoute = ({ children, type }) => {
  const { user } = useContext(AuthContext);
  if (!user) return <Navigate to="/login" />;
  if (type && user.type !== type) return <Navigate to="/login" />;
  return children;
};

const Placeholder = ({ title, color }) => (
  <div>
    <h1 className={`text-4xl font-black ${color} tracking-tight mb-4`}>{title}</h1>
    <div className="w-full h-96 bg-white rounded-[40px] border border-slate-100 shadow-sm flex items-center justify-center text-slate-300 font-medium italic">
      Modular Content Area: [Data Visualization Placeholder]
    </div>
  </div>
);
